
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stake/noundles",
      function () {
        return require("private-next-pages/stake/noundles/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stake/noundles"])
      });
    }
  